"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextfieldDescription = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/text/semantics/paragraph");
/**
 * <mm-textfield-description>
 * textfield의 보조 설명 텍스트 컴포넌트입니다.
 */
let TextfieldDescription = class TextfieldDescription extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <mm-paragraph color="light">
        <slot></slot>
      </mm-paragraph>
    `;
    }
};
TextfieldDescription = __decorate([
    (0, decorators_js_1.customElement)('mm-textfield-description')
], TextfieldDescription);
exports.TextfieldDescription = TextfieldDescription;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dGZpZWxkLWRlc2NyaXB0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidGV4dGZpZWxkLWRlc2NyaXB0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFzQztBQUN0QyxxREFBaUQ7QUFDakQsd0RBQXFEO0FBRXJEOzs7R0FHRztBQUVJLElBQU0sb0JBQW9CLEdBQTFCLE1BQU0sb0JBQXFCLFNBQVEsZ0JBQVU7SUFDbEQsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7Ozs7S0FJVixDQUFBO0lBQ0gsQ0FBQztDQUNGLENBQUE7QUFSWSxvQkFBb0I7SUFEaEMsSUFBQSw2QkFBYSxFQUFDLDBCQUEwQixDQUFDO0dBQzdCLG9CQUFvQixDQVFoQztBQVJZLG9EQUFvQiJ9